import { render } from "./yii-captcha.vue?vue&type=template&id=fbac5c08"
import script from "./yii-captcha.vue?vue&type=script&lang=js"
export * from "./yii-captcha.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__